<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex lg12 xs12 order-lg1>
        <v-card>
          <v-toolbar dense flat>
            <v-btn text icon color="green">
              <v-icon @click="returnToListing()">mdi-keyboard-backspace</v-icon>
            </v-btn>
            <v-icon>mdi-magnify </v-icon>
            <v-toolbar-title>View Claim Transaction </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="red" dark v-if="claimDetail.remove" @click.native="doPromptRemove">
              <v-icon dark left>mdi-delete</v-icon> Delete Claim
            </v-btn>
            <ButtonPrintSchedule
              v-if="!claimDetail.remove"
              labelName="Print Schedule"
              :polNo="commonInfo.polNo"
              :renCnt="commonInfo.renCnt"
              :endtCnt="commonInfo.endtCnt"
              :tranRel="true"
            ></ButtonPrintSchedule>
          </v-toolbar>
          <v-card-text class="queryClm">
            <div style="padding-left: 15px">
              <query-claim-info></query-claim-info>
            </div>
            <v-spacer class="mt-3"></v-spacer>
            <v-tabs v-model="tabMenu">
              <v-tab ripple :key="1">Claim Header</v-tab>
              <v-tab ripple :key="2">Claimant / Item / Reserve</v-tab>
              <v-tab ripple :key="3">Others</v-tab>
              <v-tab ripple :key="4">Customer Log</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabMenu">
              <v-tab-item :key="1" :transition="false" :reverse-transition="false">
                <v-card>
                  <v-card-text>
                    <query-claim-header></query-claim-header>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="2" :transition="false" :reverse-transition="false">
                <v-card>
                  <query-claimant></query-claimant>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="3" :transition="false" :reverse-transition="false">
                <v-card>
                  <v-card-text>
                    <v-expansion-panels>
                      <v-expansion-panel v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                        <v-expansion-panel-header>
                          <div>
                            <v-icon>{{ item.icon }} </v-icon>
                            <span class="headerTitle">{{ item.text }}</span>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <v-card-text>
                              <v-container fluid grid-list-lg>
                                <v-layout row wrap >
                                  <v-flex xs12 v-if="item.name === 'claimStatus'">
                                    <v-data-table
                                      :headers="claimStatusColumns"
                                      :items="claimStatusList"
                                      class="elevation-1"
                                      hide-default-footer
                                      sort-by="assignDate"
                                    >
                                      <template v-slot:item="row"
                                        ><tr>
                                          <td>{{ formatDisplayDate(row.item.statDate) }}</td>
                                          <td>{{ row.item.status }}</td>
                                          <td>{{ formatDisplayDateTime4(row.item.entDate) }}</td>
                                          <td>{{ row.item.clmStatDesc }}</td>
                                          <td>{{ row.item.cseStatDesc }}</td>
                                          <td>{{ row.item.usrName }}</td>
                                        </tr></template
                                      >
                                    </v-data-table>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimText'">
                                    <v-tabs v-model="tabNavigation">
                                      <v-tab ripple :key="0">Header</v-tab>
                                      <template v-if="claimText.claimantTexts.length > 0">
                                        <template v-for="index in claimText.claimantTexts.length">
                                          <v-tab ripple :key="index">Claimant {{ index }}</v-tab>
                                        </template>
                                      </template>
                                      <v-tab-item :key="0">
                                        <v-card>
                                          <v-card-text>
                                            <v-layout justify-left>
                                              <v-flex md4 xs12>
                                                <v-subheader class="queryLabel">{{ labels.masterText }}</v-subheader>
                                                <span class="queryValue">{{ claimText.masterText }}</span>
                                              </v-flex>
                                            </v-layout>
                                          </v-card-text>
                                        </v-card>
                                      </v-tab-item>
                                      <template v-if="claimText.claimantTexts.length > 0">
                                        <template v-for="claimant of claimText.claimantTexts">
                                          <v-tab-item :key="claimant.clmtNo">
                                            <v-card>
                                              <v-card-text>
                                                <v-flex xs12>
                                                  <v-subheader class="queryLabel">Claimant Name</v-subheader>
                                                  <span class="queryValue">{{ getClaimant(claimant.clmtNo).clmtName }}</span>
                                                </v-flex>
                                                <v-flex xs12>
                                                  <v-subheader class="queryLabel">{{ labels.claimantText + ' ' + claimant.clmtNo }}</v-subheader>
                                                  <span class="queryValue">{{ claimant.text }}</span>
                                                </v-flex>
                                                <template v-for="itemText of claimant.itemTexts">
                                                  <v-flex xs12 :key="itemText.clmtNo + itemText.clmItem">
                                                    <v-subheader class="queryLabel">{{ labels.itemText + ' ' + itemText.clmItem }}</v-subheader>
                                                    <span class="queryValue">{{ itemText.text }}</span>
                                                  </v-flex>
                                                </template>
                                              </v-card-text>
                                            </v-card>
                                          </v-tab-item>
                                        </template>
                                      </template>
                                    </v-tabs>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimHandler'">
                                    <v-data-table
                                      :headers="handlerColumns"
                                      :items="handlerList"
                                      class="elevation-1"
                                      hide-default-footer
                                      sort-by="assignDate"
                                    >
                                      <template v-slot:item="row"
                                        ><tr>
                                          <td>{{ formatDisplayDate(row.item.assignDate) }}</td>
                                          <td>{{ row.item.usrRefId }}</td>
                                          <td>{{ formatDisplayDate(row.item.reviewDate) }}</td>
                                          <td>{{ row.item.nxtRevUserRefId }}</td>
                                        </tr></template
                                      >
                                    </v-data-table>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimReservePaymentInfo'">
                                    <Claim-Reserve-Info mode="query" />
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimAttachFile'">
                                    <v-data-table :headers="attachColumns" :items="attachmentList" class="elevation-1">
                                      <template v-slot:item="row"
                                        ><tr>
                                          <td>{{ row.index + 1 }}</td>
                                          <td>{{ row.item.clmAttachFileNm }}</td>
                                          <td class="text-right">
                                            <v-tooltip>
                                              <template v-slot:activator="{ on }">
                                                <v-btn text icon color="blue" v-on="on" @click="doDownload(row.item)" class="tableActionBtn">
                                                  <v-icon>mdi-download</v-icon>
                                                </v-btn>
                                              </template>
                                              <span>Download</span>
                                            </v-tooltip>
                                          </td>
                                        </tr></template
                                      >
                                    </v-data-table>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'cedantInfo'">
                                    <Cedant-Info mode="query" :form="commonInfo" />
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'xolRecovery'">
                                    <X-O-L-Recovery mode="query" />
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'xolWrksht'">
                                    <X-O-L-Recovery-Listing :allowReview="false" :clmNo="clmNo" />
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimStats'">
                                    <v-tabs v-model="tabClmHdrStat">
                                      <v-tab ripple :key="0">Claim Header Statistics</v-tab>
                                      <v-tab-item :key="0">
                                        <v-card>
                                          <v-card-text>
                                            <v-data-table :headers="hdrStatsColumns" :items="clmHdrStatList" class="elevation-1">
                                              <template v-slot:item="row"
                                                ><tr>
                                                  <td>{{ row.item.statsType }}</td>
                                                  <td>{{ row.item.statsVal }}</td>
                                                  <td>{{ formatBooleanToNo(row.item.statsValNum) }}</td>
                                                </tr></template
                                              >
                                            </v-data-table>
                                          </v-card-text>
                                        </v-card>
                                      </v-tab-item>
                                      <v-tab ripple :key="1">Claimant Statistics</v-tab>
                                      <v-tab-item :key="1">
                                        <v-data-table :headers="clmtStatColumns" :items="clmtStatList" class="elevation-1">
                                          <template v-slot:item="row"
                                            ><tr>
                                              <td>{{ row.item.clmtNo }}</td>
                                              <td>{{ row.item.statsType }}</td>
                                              <td>{{ row.item.statsVal }}</td>
                                              <td>{{ formatBooleanToNo(row.item.statsValNum) }}</td>
                                            </tr></template
                                          >
                                        </v-data-table>
                                      </v-tab-item>
                                      <v-tab ripple :key="2">Claim Item Statistics</v-tab>
                                      <v-tab-item :key="2">
                                        <v-data-table :headers="clmItemStatCols" :items="clmItemStatList" class="elevation-1">
                                          <template v-slot:item="row"
                                            ><tr>
                                              <td>{{ row.item.clmtNo }}</td>
                                              <td>{{ row.item.clmItem }}</td>
                                              <td>{{ row.item.statsType }}</td>
                                              <td>{{ row.item.statsVal }}</td>
                                              <td>{{ formatBooleanToNo(row.item.statsValNum) }}</td>
                                            </tr></template
                                          >
                                        </v-data-table>
                                      </v-tab-item>
                                    </v-tabs>
                                    <!-- <v-card-text>
                                      <template v-if="statisticses.length > 0">
                                        <v-layout row wrap v-for="(statistics, index) in statisticses" :key="statistics.statType" align-center>
                                          <v-flex xs6>
                                            <v-subheader class="queryLabel">
                                              <span>{{statistics.statsTypeDesc}}</span>
                                            </v-subheader>
                                          </v-flex>
                                          <v-flex xs6>
                                            <v-autocomplete v-validate="{required:true}" v-model="statistics.selectedVal" :items="statistics.statValList" label="Statistics" item-text="label" item-value="value" :data-vv-name="'Statistics' + (index + 1)" :data-vv-as="'Statistics' + (index + 1)" :error-messages="errors.collect(('Statistics' + (index + 1)))"></v-autocomplete>
                                          </v-flex>
                                        </v-layout>
                                      </template>
                                      <template v-if="statisticses.length === 0">
                                        <v-layout justify-center>
                                          <div>No Statistic Found</div>
                                        </v-layout>
                                      </template>
                                    </v-card-text> -->
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimAcct'">
                                    <v-card>
                                      <v-data-table
                                        :headers="clmAcctColumns"
                                        :items="clmAcctList"
                                        class="elevation-1"
                                        :loading="clmAcctLoading"
                                        :server-items-length="clmAcctTotalItems"
                                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                        v-bind:options.sync="clmAcctPagination"
                                      >
                                        <template v-slot:item="row"
                                          ><tr>
                                            <td>{{ row.item.polNo }}</td>
                                            <td>{{ row.item.polType }}</td>
                                            <td>{{ row.item.tranType }}</td>
                                            <td>{{ row.item.docNo }}</td>
                                            <td>{{ row.item.curr }}</td>
                                            <td class="text-right">{{ formatDisplayNumber(row.item.netAmt, 2) }}</td>
                                            <td class="text-right">{{ formatDisplayNumber(row.item.osBal, 2) }}</td>
                                          </tr></template
                                        >
                                      </v-data-table>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'clmDoc'">
                                    <v-card>
                                      <v-data-table
                                        :headers="clmDocCol"
                                        :items="clmDocs"
                                        class="elevation-1"
                                        :loading="clmDocLoading"
                                        :server-items-length="clmDocTotalItems"
                                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                        v-bind:options.sync="clmDocPagination"
                                      >
                                        <template v-slot:item="row"
                                          ><tr>
                                            <td>{{ row.item.docHdgDesc }}</td>
                                            <td>{{ row.item.clmtNo }} / {{ row.item.clmItem }}</td>
                                            <td>{{ row.item.inter }}</td>
                                            <td>{{ row.item.tranType1 }}</td>
                                            <td>{{ row.item.docNo }}</td>
                                            <td>{{ formatDisplayDate(row.item.genDate) }}</td>
                                            <td>{{ formatDisplayDate(row.item.sentDate) }}</td>
                                            <td>{{ formatDisplayDate(row.item.recvDate) }}</td>
                                            <td class="text-right">
                                              <table-action :rowData="row" query @query="doClmDocQuery(row)"></table-action>
                                            </td></tr
                                        ></template>
                                      </v-data-table>
                                    </v-card>
                                    <!--Start Dialog Reivew-->
                                    <v-dialog v-model="queryDialog" width="800px" persistent>
                                      <v-card>
                                        <v-toolbar v-if="queryClmDocMode" dense flat>
                                          <v-icon>mdi-magnify</v-icon>
                                          <v-toolbar-title>Query Claims Documents</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-text>
                                          <message :messages="messages"></message>
                                          <v-container grid-list-md>
                                            <v-layout row wrap>
                                              <v-flex md6 xs12>
                                                <v-text-field
                                                  disabled
                                                  v-model="clmDocForm.docHdgDesc"
                                                  :label="clmDocLabels.docHdg"
                                                  :error-messages="errors.collect('clmDocForm.docHdgDesc')"
                                                  data-vv-name="clmDocForm.docHdgDesc"
                                                  :data-vv-as="clmDocLabels.docHdg"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex> </v-flex>
                                              <v-flex md4 xs12>
                                                <v-checkbox
                                                  color="primary"
                                                  :label="clmDocLabels.genDoc"
                                                  v-model="clmDocForm.genDoc"
                                                  :disabled="queryClmDocMode"
                                                ></v-checkbox>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                              <v-flex md6 xs12>
                                                <v-text-field
                                                  disabled
                                                  v-model="clmDocForm.clmtNoClmItem"
                                                  :label="clmDocLabels.clmtNo"
                                                  :error-messages="errors.collect('clmDocForm.clmtNoClmItem')"
                                                  data-vv-name="clmDocForm.clmtNoClmItem"
                                                  :data-vv-as="clmDocLabels.clmtNo"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex> </v-flex>
                                              <v-flex md4 xs12>
                                                <v-checkbox
                                                  color="primary"
                                                  :label="clmDocLabels.emailRecip"
                                                  v-model="clmDocForm.emailRecip"
                                                  :disabled="queryClmDocMode"
                                                ></v-checkbox>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                              <v-flex md6 xs12>
                                                <v-text-field
                                                  disabled
                                                  v-model="clmDocForm.inter"
                                                  :label="clmDocLabels.inter"
                                                  :error-messages="errors.collect('clmDocForm.inter')"
                                                  data-vv-name="clmDocForm.inter"
                                                  :data-vv-as="clmDocLabels.inter"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex> </v-flex>
                                              <v-flex md4 xs12>
                                                <v-checkbox
                                                  color="primary"
                                                  :label="clmDocLabels.smsRecip"
                                                  v-model="clmDocForm.smsRecip"
                                                  :disabled="queryClmDocMode"
                                                ></v-checkbox>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                              <v-flex md6 xs12>
                                                <v-text-field
                                                  disabled
                                                  v-model="clmDocForm.tranType1DocNo"
                                                  :label="clmDocLabels.tranType1"
                                                  :error-messages="errors.collect('clmDocForm.tranType1DocNo')"
                                                  data-vv-name="clmDocForm.tranType1DocNo"
                                                  :data-vv-as="clmDocLabels.tranType1"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex> </v-flex>
                                              <v-flex md4 xs12>
                                                <v-checkbox
                                                  color="primary"
                                                  :label="clmDocLabels.emailAgt"
                                                  v-model="clmDocForm.emailAgt"
                                                  :disabled="queryClmDocMode"
                                                ></v-checkbox>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                              <v-flex md3 xs12>
                                                <cal-picker
                                                  disabled
                                                  v-model="clmDocForm.genDate"
                                                  :label="clmDocLabels.genDate"
                                                  :data-vv-as="clmDocLabels.genDate"
                                                  data-vv-name="genDate"
                                                  :error-messages="errors.collect('genDate')"
                                                ></cal-picker>
                                              </v-flex>
                                              <v-flex md3 xs12>
                                                <v-text-field
                                                  disabled
                                                  v-model="clmDocForm.genBy"
                                                  :label="clmDocLabels.genBy"
                                                  :error-messages="errors.collect('clmDocForm.genBy')"
                                                  data-vv-name="clmDocForm.genBy"
                                                  :data-vv-as="clmDocLabels.genBy"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex> </v-flex>
                                              <v-flex md4 xs12>
                                                <v-checkbox
                                                  color="primary"
                                                  :label="clmDocLabels.smsAgt"
                                                  v-model="clmDocForm.smsAgt"
                                                  :disabled="queryClmDocMode"
                                                ></v-checkbox>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                              <v-flex md3 xs12>
                                                <cal-picker
                                                  v-model="clmDocForm.sentDate"
                                                  :label="clmDocLabels.sentDate"
                                                  :data-vv-as="clmDocLabels.sentDate"
                                                  data-vv-name="sentDate"
                                                  :error-messages="errors.collect('sentDate')"
                                                  :disabled="disabledSentDate"
                                                ></cal-picker>
                                              </v-flex>
                                              <v-flex md3 xs12>
                                                <v-text-field
                                                  disabled
                                                  v-model="clmDocForm.sentBy"
                                                  :label="clmDocLabels.sentBy"
                                                  :error-messages="errors.collect('clmDocForm.sentBy')"
                                                  data-vv-name="clmDocForm.sentBy"
                                                  :data-vv-as="clmDocLabels.sentBy"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex> </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                              <v-flex md3 xs12>
                                                <cal-picker
                                                  :disabled="disabledRecvDate"
                                                  v-model="clmDocForm.recvDate"
                                                  :label="clmDocLabels.recvDate"
                                                  :data-vv-as="clmDocLabels.recvDate"
                                                  data-vv-name="recvDate"
                                                  :error-messages="errors.collect('recvDate')"
                                                ></cal-picker>
                                              </v-flex>
                                            </v-layout>
                                            <v-spacer class="mt-2"></v-spacer>
                                            <v-layout row wrap>
                                              <v-flex md6 xs6>
                                                <v-subheader class="queryLabel">{{ clmDocLabels.createdBy }}</v-subheader>
                                                <div class="queryValue">{{ clmDocForm.createdBy }}</div>
                                              </v-flex>
                                              <v-flex md6 xs6>
                                                <v-subheader class="queryLabel">{{ clmDocLabels.createdDate }}</v-subheader>
                                                <div class="queryValue">{{ formatDisplayDate(clmDocForm.createdDate) }}</div>
                                              </v-flex>
                                            </v-layout>
                                            <v-spacer class="mt-1"></v-spacer>
                                            <v-layout row wrap>
                                              <v-flex md6 xs6>
                                                <v-subheader class="queryLabel">{{ clmDocLabels.modifiedBy }}</v-subheader>
                                                <div class="queryValue">{{ clmDocForm.modifiedBy }}</div>
                                              </v-flex>
                                              <v-flex md6 xs6>
                                                <v-subheader class="queryLabel">{{ clmDocLabels.modifiedDate }}</v-subheader>
                                                <div class="queryValue">{{ formatDisplayDate(clmDocForm.modifiedDate) }}</div>
                                              </v-flex>
                                            </v-layout>
                                          </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn color="red darken-1" text @click.native="doQueryClose">Cancel</v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'clmByLossDate'">
                                    <v-card>
                                      <v-data-table
                                        :headers="clmByLossDateColumns"
                                        :items="clmByLossDateList"
                                        class="elevation-1"
                                        :loading="clmByLossDateLoading"
                                        :server-items-length="clmByLossDateTotalItems"
                                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                        v-bind:options.sync="clmByLossDatePagination"
                                      >
                                        <template v-slot:item="row"
                                          ><tr>
                                            <td>{{ row.item.clmNo }}</td>
                                            <td>{{ row.item.polNo }}</td>
                                            <td>{{ row.item.insdName1 }}</td>
                                            <td>{{ row.item.busCls }}</td>
                                          </tr></template
                                        >
                                      </v-data-table>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'clmHistory'">
                                    <v-card>
                                      <v-data-table
                                        v-bind:headers="clmHitoryColumns"
                                        v-bind:items="historyItems"
                                        :server-items-length="clmHistoryTotalItems"
                                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                        v-bind:options.sync="clmHistoryPagination"
                                        item-key="key"
                                        :loading="clmHistoryLoading"
                                        :no-data-text="noDataText"
                                        class="elevation-1"
                                      >
                                        <template v-slot:item="row"
                                          ><tr>
                                            <td>{{ row.item.entDate }}</td>
                                            <td>{{ row.item.clmStatDesc }}</td>
                                            <td>{{ row.item.clmtNo }}</td>
                                            <td>{{ row.item.clmItem }}</td>
                                            <td>{{ row.item.tranType1 }}</td>
                                            <td>{{ row.item.docNo }}</td>
                                            <td>{{ row.item.clmResCat }}</td>
                                            <td>{{ row.item.amtLoc }}</td>
                                            <td>{{ row.item.usrRefId }}</td>
                                          </tr></template
                                        >
                                      </v-data-table>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimRI'">
                                    <v-card>
                                      <v-data-table
                                        :headers="claimRIColumns"
                                        :items="claimRIList"
                                        :server-items-length="claimRITotalItems"
                                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                        v-bind:options.sync="pagination"
                                        item-key="key"
                                        :loading="loading"
                                        :no-data-text="noDataText"
                                        class="elevation-1"
                                      >
                                        <template v-slot:item="row"
                                          ><tr>
                                            <td>{{ row.item.riTypeDesc }}</td>
                                            <td>{{ row.item.riCo }} {{ row.item.riCoDesc }}</td>
                                            <td>{{ row.item.acctNoSfx }}</td>
                                            <td>{{ row.item.verCnt }}</td>
                                            <td>{{ row.item.proplXolDesc }}</td>
                                            <td>{{ formatDisplayNumber(row.item.riSipct, 6) }}</td>
                                            <td class="text-right">
                                              <table-action :rowData="row" query @query="doView(row)"></table-action>
                                            </td></tr
                                        ></template>
                                      </v-data-table>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'clmMtrDrvr'">
                                    <v-card>
                                      <v-card-text v-if="clmMtrDrvrLoading">
                                        <v-layout row wrap>
                                          <v-progress-linear indeterminate />
                                        </v-layout>
                                      </v-card-text>
                                      <v-card-text v-else>
                                        <v-container grid-list-md>
                                          <v-layout wrap>
                                            <v-flex sm6 xs12>
                                              <v-subheader class="queryLabel">Insured Claim Reference</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.insdClmRefNo }}</span>
                                            </v-flex>
                                            <v-flex sm6 xs12>
                                              <v-subheader class="queryLabel">NRIC No.</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.drvIcNo }}</span>
                                            </v-flex>
                                            <v-flex xs12>
                                              <v-subheader class="queryLabel">Name</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.drvName }}</span>
                                            </v-flex>
                                            <v-flex xs12>
                                              <v-subheader class="queryLabel">Address</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.addr1 }}</span>
                                              <span class="queryValue"> {{ clmMtrDrvr.addr2 }}</span>
                                              <span class="queryValue"> {{ clmMtrDrvr.addr3 }}</span>
                                              <span class="queryValue"> {{ clmMtrDrvr.addr4 }}</span>
                                            </v-flex>
                                            <v-flex xs12>
                                              <v-subheader class="queryLabel">Post Code</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.postCode }}</span>
                                            </v-flex>
                                            <v-flex sm6 xs12>
                                              <v-subheader class="queryLabel">Telephone No.</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.telNo1 }}</span>
                                            </v-flex>
                                            <v-flex sm6 xs12>
                                              <v-subheader class="queryLabel">Mobile No.</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.telNo2 }}</span>
                                            </v-flex>
                                            <v-flex sm6 xs12>
                                              <v-subheader class="queryLabel">Gender</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.drvGender }}</span>
                                            </v-flex>
                                            <v-flex sm3 xs12>
                                              <v-subheader class="queryLabel">Date of Birth</v-subheader>
                                              <span class="queryValue">{{ formatDisplayDate(clmMtrDrvr.drvDob) }}</span>
                                            </v-flex>
                                            <v-flex sm3 xs12>
                                              <v-subheader class="queryLabel">Age</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.drvAge }}</span>
                                            </v-flex>
                                            <v-flex sm6 xs12>
                                              <v-subheader class="queryLabel">License Type</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.drvLicType }}</span>
                                            </v-flex>
                                            <v-flex sm6 xs12>
                                              <v-subheader class="queryLabel">License Expiry Date</v-subheader>
                                              <span class="queryValue">{{ formatDisplayDate(clmMtrDrvr.drvLicExpDate) }}</span>
                                            </v-flex>
                                            <v-flex sm4 xs12>
                                              <v-subheader class="queryLabel">Fault 1</v-subheader>
                                              <span class="queryValue">{{ clmMtrDrvr.fault1 }}</span>
                                            </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card-text>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimRemark'">
                                    <v-data-table
                                      :headers="claimRemarkColumns"
                                      :items="claimRemarkList"
                                      class="elevation-1"
                                      hide-default-footer
                                      sort-by="assignDate"
                                    >
                                      <template v-slot:item="row"
                                        ><tr>
                                          <td>{{ formatDisplayDate(row.item.createdDate) }}</td>
                                          <td>{{ row.item.createdBy }}</td>
                                          <td>{{ row.item.remarks }}</td>
                                          <td>{{ formatDisplayDate(row.item.modifiedDate) }}</td>
                                          <td>{{ row.item.modifiedBy }}</td>
                                        </tr></template
                                      >
                                    </v-data-table>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimPayment'">
                                    <v-card>
                                      <v-data-table
                                        :headers="paymentColumns"
                                        :items="payments"
                                        class="elevation-1"
                                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                      >
                                        <template v-slot:item="row"
                                          ><tr>
                                            <td>{{ row.item.clmtNo }}</td>
                                            <td>{{ row.item.clmItem }}</td>
                                            <td>{{ row.item.clmResCat }}</td>
                                            <td>{{ row.item.status }}</td>
                                            <td>{{ row.item.branch }}</td>
                                            <td>{{ formatDisplayDate(row.item.tranDate) }}</td>
                                            <td>{{ row.item.tranType }}</td>
                                            <td>{{ row.item.docNo }}</td>
                                            <td>{{ row.item.acctMth }} / {{ row.item.acctYr }}</td>
                                            <td>{{ row.item.curr }}</td>
                                            <td class="text-right">{{ row.item.paytAmt }}</td>
                                            <td>{{ formatBoolean(row.item.docPrtd) }}</td>
                                            <td>{{ formatBoolean(row.item.tranRel) }}</td>
                                            <td class="text-right">
                                              <table-action :rowData="row" query @query="doQuery(row)"></table-action>
                                            </td></tr
                                        ></template>
                                      </v-data-table>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimReserve'">
                                    <v-card>
                                      <v-data-table :headers="reserveColumns" :items="reserves" class="elevation-1"
                                      :footer-props="{ 'items-per-page-options': itemsPerPage }">
                                        <template v-slot:item="row"
                                          ><tr>
                                            <td>{{ row.item.clmtNo }}</td>
                                            <td>{{ row.item.clmItem }}</td>
                                            <td>{{ row.item.clmResCat }}</td>
                                            <td>{{ row.item.status }}</td>
                                            <td>{{ formatDisplayDate(row.item.tranDate) }}</td>
                                            <td>{{ row.item.acctMth }} / {{ row.item.acctYr }}</td>
                                            <td class="text-right">{{ row.item.reserve }}</td>
                                            <td class="text-right">{{ row.item.reserveLoc }}</td>
                                            <td>{{ formatDisplayDateTime4(row.item.entryDate) }}</td>
                                            <td>{{ row.item.userName }}</td>
                                          </tr></template
                                        >
                                      </v-data-table>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'claimRlRcvy'">
                                    <v-card>
                                      <v-data-table
                                        :headers="riRcvyColumns"
                                        :items="riRecoveries"
                                        id="scroll-table"
                                        v-scroll:#scroll-table="onScroll"
                                        class="elevation-1"
                                        fixed-header
                                        :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                      >
                                        <template v-slot:item="row"
                                          ><tr>
                                            <!-- <td>{{ row.item.clmtNo }} / {{ row.item.clmItem }} / {{ row.item.clmResCat }}</td> -->
                                            <td>{{ row.item.clmtNo }}</td>
                                            <td>{{ row.item.clmItem }}</td>
                                            <td>{{ row.item.clmResCat }}</td>
                                            <td>{{ row.item.orgTranType }} {{ row.item.orgDocNo }}</td>
                                            <!-- <td>{{ row.item.orgDocNo }}</td> -->
                                            <!-- <td>
                                              <tr>
                                                <td>{{ row.item.orgTranType }}</td>
                                              </tr>
                                              <tr>
                                                <td>{{ row.item.orgDocNo }}</td>
                                              </tr>
                                            </td> -->
                                            <!-- <td>
                                              <tr>
                                                <td>{{ row.item.riType }}</td>
                                              </tr>
                                              <tr>
                                                <td>{{ row.item.riCo }}</td>
                                              </tr>
                                            </td> -->
                                            <td>{{ row.item.riType }}</td>
                                            <td>{{ row.item.riCo }}</td>
                                            <td>{{ row.item.acctNoSfx }}</td>
                                            <!-- <td>{{ row.item.riCo }}</td> -->
                                            <td>{{ row.item.curr }}</td>
                                            <td class="text-right">{{ row.item.rcvyAmt }}</td>
                                            <!-- <td class="text-right">{{ row.item.rcvyAmtLoc }}</td> -->
                                            <td class="text-right">{{ row.item.rcvredAmtLoc }}</td>
                                            <td>{{ row.item.rcvyDocNo }}</td>
                                            <td>{{ formatDisplayDate(row.item.tranDate) }}</td>
                                            <!-- <td>
                                              <tr>{{ formatDisplayDate(row.item.tranDate) }}</tr>
                                              <tr>{{ row.item.acctMth }} / {{ row.item.acctYr }}</tr>
                                            </td> -->
                                            <td>{{ row.item.acctMth }} / {{ row.item.acctYr }}</td>
                                            <!-- <td>{{ row.item.rcvyDocNo }}</td> -->
                                            <td>{{ formatDisplayDateTime4(row.item.createdDate) }}</td>
                                            <td>{{ row.item.usrRefId }}</td>
                                          </tr></template
                                        >
                                      </v-data-table>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'keyRisk'">
                                    <v-tabs v-model="tabKeyRisk">
                                      <v-tab ripple :key="0" v-if="displayMtrRisk">Motor Risk</v-tab>
                                      <v-tab-item :key="0" v-if="displayMtrRisk">
                                        <v-card>
                                          <v-card-text>
                                            <message :messages="messages"></message>
                                            <v-container grid-list-md>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.yrManuf }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.yrManuf }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.logBook }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.logBook }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.vehRegNo }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.vehRegNo }}</div>
                                                </v-flex>
                                              </v-layout>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.engNo }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.engNo }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.chasNo }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.chasNo }}</div>
                                                </v-flex>
                                              </v-layout>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.vehMake }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.vehMake }} - {{ commonInfo.vehMakeDesc }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.vehModel }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.vehModel }} - {{ commonInfo.vehModelDesc }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.vehVsl }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.vehVsl }}</div>
                                                </v-flex>
                                              </v-layout>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.liabCode }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.liabCode }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.liabPct }}</v-subheader>
                                                  <div class="queryValue" v-if="commonInfo.liabPct">
                                                    {{ formatDisplayNumber(commonInfo.liabPct, 2) }}
                                                  </div>
                                                  <span class="queryValue" v-else>0.00</span>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.acceptDate }}</v-subheader>
                                                  <div class="queryValue">{{ formatDisplayDate(commonInfo.acceptDate) }}</div>
                                                </v-flex>
                                              </v-layout>
                                            </v-container>
                                          </v-card-text>
                                        </v-card>
                                      </v-tab-item>
                                      <v-tab ripple :key="1" v-if="displayFireRisk">Fire Risk</v-tab>
                                      <v-tab-item :key="1" v-if="displayFireRisk">
                                        <v-card>
                                          <v-card-text>
                                            <message :messages="messages"></message>
                                            <v-container grid-list-md>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.distCls }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.distCls }} - {{ keyRiskForm.distClsDesc }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.constnCls }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.constnCls }} - {{ keyRiskForm.constnClsDesc }}</div>
                                                </v-flex>
                                              </v-layout>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.occpnCls }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.occpnCls }} - {{ keyRiskForm.occpnClsDesc }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.occpClsLim }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.occpClsLim }} - {{ keyRiskForm.occpClsLimDesc }}</div>
                                                </v-flex>
                                              </v-layout>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.acceptDate }}</v-subheader>
                                                  <div class="queryValue">{{ formatDisplayDate(commonInfo.acceptDate) }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.riskPostCode }}</v-subheader>
                                                  <div class="queryValue" v-if="commonInfo.riskPostCode">{{ commonInfo.riskPostCode }}</div>
                                                  <span v-else>-</span>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.riskLoc }}</v-subheader>
                                                  <div v-if="commonInfo.riskLoc">{{ commonInfo.riskLoc }}</div>
                                                  <span v-else>-</span>
                                                </v-flex>
                                              </v-layout>
                                            </v-container>
                                          </v-card-text>
                                        </v-card>
                                      </v-tab-item>
                                      <v-tab ripple :key="2" v-if="displayMiscRisk">Miscellaneous Risk</v-tab>
                                      <v-tab-item :key="2" v-if="displayMiscRisk">
                                        <v-card>
                                          <v-card-text>
                                            <message :messages="messages"></message>
                                            <v-container grid-list-md>
                                              <v-layout wrap>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.retroDate }}</v-subheader>
                                                  <div class="queryValue">{{ formatDisplayDate(commonInfo.retroDate) }}</div>
                                                </v-flex>
                                                <v-flex md4 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.acceptDate }}</v-subheader>
                                                  <div class="queryValue">{{ formatDisplayDate(commonInfo.acceptDate) }}</div>
                                                </v-flex>
                                              </v-layout>
                                            </v-container>
                                          </v-card-text>
                                        </v-card>
                                      </v-tab-item>
                                      <v-tab ripple :key="3" v-if="displayCargoRisk || displayHullRisk">Cargo / Hull Risk</v-tab>
                                      <v-tab-item :key="3" v-if="displayCargoRisk || displayHullRisk">
                                        <v-card>
                                          <v-card-text>
                                            <message :messages="messages"></message>
                                            <v-container grid-list-md>
                                              <v-layout wrap>
                                                <v-flex md6 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.vesNo }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.vesNo }}</div>
                                                </v-flex>
                                                <v-flex md6 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.vesName }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.vesName }}</div>
                                                </v-flex>
                                                <v-flex md6 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.voyNo }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.voyNo }}</div>
                                                </v-flex>
                                                <v-flex md6 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.voyDesc }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.voyDesc }}</div>
                                                </v-flex>
                                              </v-layout>
                                              <v-layout wrap>
                                                <v-flex md6 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.acceptDate }}</v-subheader>
                                                  <div class="queryValue">{{ formatDisplayDate(commonInfo.acceptDate) }}</div>
                                                </v-flex>
                                                <v-flex md6 xs12>
                                                  <v-subheader class="queryLabel">{{ keyRisklabel.vehVsl }}</v-subheader>
                                                  <div class="queryValue">{{ commonInfo.vehVsl }}</div>
                                                </v-flex>
                                              </v-layout>
                                            </v-container>
                                          </v-card-text>
                                        </v-card>
                                      </v-tab-item>
                                      <v-tab ripple :key="4" v-if="displayNoData"></v-tab>
                                      <v-tab-item :key="4" v-if="displayNoData">
                                        <v-card>
                                          <v-card-text>
                                            <v-container grid-list-md>
                                              <v-layout wrap>
                                                <v-flex md12 xs12>
                                                  <span>No Data Available</span>
                                                </v-flex>
                                              </v-layout>
                                            </v-container>
                                          </v-card-text>
                                        </v-card>
                                      </v-tab-item>
                                    </v-tabs>
                                  </v-flex>
                                  <v-flex xs12 v-if="item.name === 'polMaster'">
                                    <v-btn small color="primary" @click.native="redirect">Click to view Policy Master</v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="4" :transition="false" :reverse-transition="false">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <CustLog :manageType="manageType"></CustLog>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <loader
      v-else
      :card="false"
      :height="425"
      :init="doInit"
      loadText="Loading Claim Details..."
      errorText="Failed to load Claim Details"
      :loading="initStatus === 0"
    ></loader>
    <v-dialog v-model="showDeletePrompt" persistent width="360px">
      <v-card>
        <v-card-text> Are you sure you want to delete claim {{ commonInfo.clmNo }}? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat text @click.native="doRemove" :loading="loading"> Delete </v-btn>
          <v-btn color="secondary" flat text @click.native="showDeletePrompt = false" :loading="loading"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDeleteConfirm" persistent width="360px">
      <v-card>
        <v-card-text> The Claim has been deleted. (70205) </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="doExit"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingModal" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import QueryClaimInfo from './QueryClaimInfo'
import QueryClaimHeader from './QueryClaimHeader'
import QueryClaimant from './QueryClaimant'
import ClaimReserveInfo from '@/components/core/claimManagement/subInfo/ClaimReserveInfo'
import CedantInfo from '@/components/core/claimManagement/subInfo/CedantInfo'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime4, yearDiff } from '@/utils/date'
import clone from 'clone'
import { listMixin } from '@/mixins/listMixin'
import * as TableConst from '@/mixins/table'
import { downloadPrompt } from '@/utils/file'
import { formatDisplayNumber } from '@/utils/number'
import CustLog from '../../underwriting/policy/query/QueryCustomerLog'
import ButtonPrintSchedule from '@/components/core/common/button/ButtonPrintSchedule.vue'
import XOLRecoveryListing from '@/components/core/claimManagement/xolRecovery/XOLRecoveryListing'
import XOLRecovery from '@/components/core/claimManagement/sideFunction/XOLRecovery'
export default {
  data() {
    return {
      loadingModal: false,
      loading: false,
      queryMode: false,
      reviewDialog: false,
      queryDialog: false,
      show: false,
      displayMtrRisk: false,
      displayFireRisk: false,
      displayMiscRisk: false,
      displayCargoRisk: false,
      displayHullRisk: false,
      displayNoData: false,
      showDeletePrompt: false,
      showDeleteConfirm: false,
      tabMenu: undefined,
      labels: {
        masterText: 'Header Text',
        claimantText: 'Claimant Text',
        itemText: 'Item Text'
      },
      claimText: {
        clmNo: undefined,
        masterText: undefined,
        claimantTexts: [],
        itemTexts: [],
        riType: 'Reinsurance Type',
        riCo: 'CO / RI Company/Treaty',
        acctNoSfx: 'Suffix',
        proplXol: 'Proportional / XOL',
        riSipct: 'RI Sum Insured %',
        riLim: 'RI Limit',
        priority: 'Priority Limit'
      },
      tabNavigation: 0,
      tabClmHdrStat: 0,
      tabKeyRisk: 0,
      claimStatusColumns: [
        { text: 'Date of Status', align: 'left', value: 'statDate' },
        { text: 'Auth', align: 'left', value: 'status' },
        { text: 'Entry Date', align: 'left', value: 'entDate' },
        { text: 'Status', align: 'left', value: 'clmStat' },
        { text: 'Cause of Status', align: 'left', value: 'cseStat' },
        { text: 'User ID', align: 'left', value: 'usrId' }
      ],
      handlerColumns: [
        { text: 'Assign Date', align: 'left', sortable: false, value: 'assignDate' },
        { text: 'Assign User ID', align: 'left', sortable: false, value: 'userId' },
        { text: 'Next Review Date', align: 'left', sortable: false, value: 'reviewDate' },
        { text: 'Next Review User ID', align: 'left', sortable: false, value: 'nxtRevUsrId' }
      ],
      claimRemarkColumns: [
        { text: 'Ent Date', align: 'left', value: 'createdDate' },
        { text: 'Ent By', align: 'left', value: 'createdBy' },
        { text: 'Remarks', align: 'left', value: 'remarks' },
        { text: 'Mod Date', align: 'left', value: 'modifiedDate' },
        { text: 'Mod By', align: 'left', value: 'modifiedBy' }
      ],
      hdrStatsColumns: [
        { text: 'Statistics Type', align: 'left', value: 'statsType' },
        { text: 'Statistics Value', align: 'left', value: 'statsVal' },
        { text: 'Statistics Value No.', align: 'left', value: 'statsValNum' }
      ],
      clmtStatColumns: [
        { text: 'Claimant No.', align: 'left', value: 'clmtNo' },
        { text: 'Statistics Type', align: 'left', value: 'statsType' },
        { text: 'Statistics Value', align: 'left', value: 'statsVal' },
        { text: 'Statistics Value No.', align: 'left', value: 'statsValNum' }
      ],
      clmItemStatCols: [
        { text: 'Claimant No.', align: 'left', value: 'clmtNo' },
        { text: 'Claim Item', align: 'left', value: 'clmItem' },
        { text: 'Statistics Type', align: 'left', value: 'statsType' },
        { text: 'Statistics Value', align: 'left', value: 'statsVal' },
        { text: 'Statistics Value No.', align: 'left', value: 'statsValNum' }
      ],
      attachmentList: [],
      claimRemarkList: [],
      claimPaymentList: [],
      claimPays: [],
      clmPayHdrs: [],
      clmHdrStatList: [],
      clmItemStatList: [],
      clmtStatList: [],
      menu: [],
      attachColumns: [
        { text: 'S/N', align: 'left', sortable: false },
        { text: 'File Name', align: 'left', sortable: false },
        TableConst.tableActionHeader
      ],
      claimRIColumns: [
        { text: 'RI Type', align: 'left', value: 'riTypeDesc' },
        { text: 'CO / RI Company/Treaty', value: 'riCo' },
        { text: 'Suffix', value: 'acctNoSfx' },
        { text: 'Version', value: 'verCnt' },
        { text: 'Proportional / XOL', value: 'proplXolDesc' },
        { text: 'RI Sum Insured %', value: 'riSipct' },
        TableConst.tableActionHeader
      ],
      mode: 'list',
      paymentColumns: [
        { text: 'Clmt No.', align: 'left', value: 'clmtNo' },
        { text: 'Item', align: 'left', value: 'clmItem' },
        { text: 'Res Catg.', align: 'left', value: 'clmResCat' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Tran Date', align: 'left', value: 'tranDate' },
        { text: 'Type', align: 'left', value: 'tranType' },
        { text: 'Doc No.', align: 'left', value: 'docNo' },
        { text: 'Acct Period', align: 'left', value: 'acctMth' },
        { text: 'Payt Curr', align: 'left', value: 'curr' },
        { text: 'Payt Amt', align: 'left', value: 'paytAmt' },
        { text: 'Doc Printed', align: 'left', value: 'docPrtd' },
        // { text: 'Acct Year', align: 'left', value: 'acctYr' },
        { text: 'TranRel', align: 'left', value: 'tranRel' },
        // { text: 'Payt Amt Res', align: 'left', value: 'paytAmtRes' },
        // { text: 'Entry Date', align: 'left', value: 'createdDate' },
        // { text: 'User ID', align: 'left', value: 'createdBy' },
        { text: 'Details', align: 'left', value: 'details' }
      ],
      reserveColumns: [
        { text: 'Clmt No.', align: 'left', value: 'clmtNo' },
        { text: 'Item', align: 'left', value: 'clmItem' },
        { text: 'Res Catg.', align: 'left', value: 'clmResCat' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Tran Date', align: 'left', value: 'tranDate' },
        { text: 'Acct Period', align: 'left', value: 'acctMth' },
        // { text: 'Acct Year', align: 'left', value: 'acctYr' },
        { text: 'Reserve Amount', align: 'right', value: 'reserve' },
        { text: 'Reserve Amount Local', align: 'right', value: 'reserveLoc' },
        { text: 'Entry Date', align: 'left', value: 'entryDate' },
        { text: 'User ID', align: 'left', value: 'userId' }
      ],
      riRcvyColumns: [
        { text: 'Clmt No.', align: 'left', value: 'clmtNo' },
        { text: 'Clm Item', align: 'left', value: 'clmItem' },
        { text: 'Res Catg', align: 'left', value: 'clmResCat' },
        // { text: 'Orig Doc', align: 'left', value: 'orgTranType' },
        { text: 'Orig Doc No.', align: 'left', value: 'orgDocNo' },
        { text: 'RI Type', align: 'left', value: 'riType' },
        { text: 'RI Co', align: 'left', value: 'riCo' },
        { text: 'Sfx', align: 'left', value: 'acctNoSfx' },
        { text: 'Rcvy Curr', align: 'left', value: 'curr' },
        { text: 'Rcvy Amt', align: 'right', value: 'rcvyAmt' },
        // { text: 'Rcvy Amt Loc', align: 'right', value: 'rcvyAmtLoc' },
        { text: 'Rcvred Amt', align: 'right', value: 'rcvredAmtLoc' },
        { text: 'Rcvy DocNo', align: 'left', value: 'rcvyDocNo' },
        { text: 'Tran Date', align: 'left', value: 'tranDate' },
        { text: 'Acct Period', align: 'left', value: 'acctMth' },
        // { text: 'Acct Year', align: 'left', value: 'acctYr' },
        { text: 'Entry Date    ', align: 'left', value: 'createdDate' },
        { text: 'User ID', align: 'left', value: 'createdBy' }
      ],
      selected: {
        clmNo: undefined,
        clmtNo: undefined,
        clmItem: undefined,
        docNo: undefined,
        tranType: undefined
      },
      keyRisklabel: {
        yrManuf: 'Year of Manufacture',
        logBook: 'Log Book No.',
        vehRegNo: 'Vehicle Reg No.',
        engNo: 'Engine No.',
        chasNo: 'Chassic No.',
        vehMake: 'Vehicle Make',
        vehModel: 'Vehicle Model',
        liabCode: 'Liability Code',
        liabPct: 'Liability %',
        acceptDate: 'Acceptance Date',
        distCls: 'District Class',
        constnCls: 'Construction Class',
        occpnCls: 'Occupation Class',
        occpClsLim: 'Occupation Class Limit',
        retroDate: 'Retroactive Date',
        vesNo: 'Vessel No.',
        vesName: 'Vessel Name Test',
        vehVsl: 'Vehicle / Vessel Notes',
        voyNo: 'Voyage No.',
        voyDesc: 'Voyage Description',
        riskPostCode: 'Risk Postal Code',
        riskLoc: 'Risk Location'
      },
      keyRiskForm: {
        distClsDesc: undefined,
        constnClsDesc: undefined,
        occpnClsDesc: undefined,
        occpClsLimDesc: undefined
      },
      clmMtrDrvrLoading: true,
      clmMtrDrvr: {
        insdClmRefNo: undefined,
        drvIcNo: undefined,
        drvName: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        postCode: undefined,
        telNo1: undefined,
        telNo2: undefined,
        drvGender: undefined,
        drvDob: undefined,
        drvAge: 0,
        drvLicType: undefined,
        drvLicExpDate: undefined,
        fault1: undefined
      },
      manageType: 'claims',
      clmByLossDateLoading: false,
      clmHistoryLoading: false,
      clmByLossDateList: [],
      historyItems: [],
      clmByLossDateTotalItems: 0,
      clmByLossDatepagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      clmByLossDateColumns: [
        { text: 'Claim No.', align: 'left', value: 'clmNo' },
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Insured Name', align: 'left', value: 'insdName1' },
        { text: 'Class', align: 'left', value: 'busCls' }
      ],
      clmHitoryColumns: [
        { text: 'Entry Date', align: 'left', value: 'entDate' },
        { text: 'Status', align: 'left', value: 'clmStatDesc' },
        { text: 'Claimant', align: 'left', value: 'clmtNo' },
        { text: 'Item', align: 'left', value: 'clmItem' },
        { text: 'TranType', align: 'left', value: 'tranType' },
        { text: 'DocNo', align: 'left', value: 'docNo' },
        { text: 'Res/Payt Cat.', align: 'left', value: 'clmResCat' },
        { text: 'Local Amt', align: 'left', value: 'amtLoc' },
        { text: 'User ID', align: 'left', value: 'usrRefId' }
      ],
      clmDocCol: [
        { text: 'Claim Document', align: 'left', value: 'docHdgDesc' },
        { text: 'Claimant / Item', align: 'left', value: 'clmtNo' },
        { text: 'Service Provider', align: 'left', value: 'inter' },
        { text: 'Tran Type 1', align: 'left', value: 'tranType1' },
        { text: 'Doc No.', align: 'left', value: 'docNo' },
        { text: 'Gen Date', align: 'left', value: 'genDate' },
        { text: 'Sent Date.', align: 'left', value: 'sentDate' },
        { text: 'Recd Date', align: 'left', value: 'recvDate' },
        TableConst.tableActionHeader
      ],
      clmDocLoading: false,
      queryClmDocMode: false,
      disabledSentDate: false,
      disabledRecvDate: false,
      clmDocs: [],
      clmDocTotalItems: 0,
      clmDocpagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      clmAcctLoading: false,
      clmAcctList: [],
      interlist: [],
      clmAcctTotalItems: 0,
      clmAcctpagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      clmDocNoList: [
        { code: '620', value: 'Claims Acknowledgement Letter', codeValue: '620 - Claims Acknowledgement Letter' },
        { code: '622', value: 'Documentation Request Letter', codeValue: '622 - Documentation Request Letter' },
        { code: '623', value: 'Service Provider Appointment Letter', codeValue: '623 - Service Provider Appointment Letter' },
        { code: '624', value: 'Offer Settlement Letter', codeValue: '624 - Offer Settlement Letter' },
        { code: '625', value: 'Discharge Voucher', codeValue: '625 - Discharge Voucher' },
        { code: '626', value: 'Subrogation Form', codeValue: '626 - Subrogation Form' },
        { code: '627', value: 'Counter Guarantee Letter', codeValue: '627 - Counter Guarantee Letter' },
        { code: '628', value: 'Third Party Claimant PDPA', codeValue: '628 - Third Party Claimant PDPA' }
      ],
      clmDocLabels: {
        polType: 'Policy Type',
        prtAckLtr: 'Print',
        documentNo: 'docNo input',
        docHdg: 'Claim Doc',
        clmtNo: 'Claimant No. / Claim Item',
        clmItem: 'Claim Item',
        inter: 'Service Provider',
        tranType1: 'Tran Type 1 / Doc No.',
        docNo: 'Doc No.',
        genDate: 'Generated Date',
        genBy: 'Generated By',
        sentDate: 'Sent Date',
        sentBy: 'Sent By',
        recvDate: 'Received Date',
        recvBy: 'Received By',
        genDoc: 'Generate Document',
        emailRecip: 'Email Recipient',
        smsRecip: 'SMS Recipient',
        emailAgt: 'Email Agent',
        smsAgt: 'SMS Agent',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      clmDocForm: {
        documentNo: '',
        docHdg: undefined,
        docHdgDesc: undefined,
        clmtNo: undefined,
        clmItem: undefined,
        clmtNoClmItem: undefined,
        inter: undefined,
        tranType1: undefined,
        docNo: undefined,
        tranType1DocNo: undefined,
        genDate: undefined,
        genBy: undefined,
        sentDate: undefined,
        sentBy: undefined,
        recvDate: undefined,
        genDoc: false,
        emailRecip: false,
        smsRecip: false,
        emailAgt: false,
        smsAgt: false,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined,
        tranId: undefined,
        clmNo: undefined,
        clmResCat: undefined,
        branch: undefined,
        recvBy: undefined,
        delDoc: undefined
      },
      clmAcctColumns: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Pol Type', align: 'left', value: 'polType' },
        { text: 'Type', align: 'left', value: 'tranType' },
        { text: 'Doc No.', align: 'left', value: 'docNo' },
        { text: 'Currency', align: 'left', value: 'curr' },
        { text: 'Doc Amount', align: 'right', value: 'netAmt' },
        { text: 'Balance', align: 'right', value: 'osBal' }
      ],
      clmAcctPagination: {
        page: 1
      },
      clmDocPagination: {
        page: 1
      },
      clmByLossDatePagination: {
        page: 1
      },
      clmHistoryPagination: {
        page: 1,
        itemsPerPage: 5,
        sortDesc: [false]
      },
      clmHistoryTotalItems: 0,
      start: 0,
      timeout: null,
      rowHeight: 24,
      perPage: 25,
      claimRITotalItems: 0,
      claimRIList: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  computed: {
    sideMenu() {
      let arr = [
        { name: 'claimAcct', text: 'Accounts Master', icon: 'mdi-library-books' },
        { name: 'claimAttachFile', text: 'Attachments', icon: 'mdi-file-multiple' },
        { name: 'cedantInfo', text: 'Cedant Info', icon: 'mdi-network' },
        { name: 'clmDoc', text: 'Claims Documents', icon: 'mdi-file-document' },
        { name: 'clmHistory', text: 'Claims History', icon: 'mdi-history' },
        { name: 'clmByLossDate', text: 'Claims of Similar Date of Loss', icon: 'mdi-compare' }
      ]
      if (this.$store.state.claims.claimDetail.commonInfo.appID === 'MO') {
        arr.push({ name: 'clmMtrDrvr', text: 'Driver Details', icon: 'mdi-account-card-details' })
      }
      arr.push({ name: 'claimHandler', text: 'Handler', icon: 'mdi-account-check' })
      arr.push({ name: 'keyRisk', text: 'Key Risk', icon: 'mdi-view-list' })
      arr.push({ name: 'claimPayment', text: 'Payments', icon: 'mdi-cash-multiple' })
      arr.push({ name: 'polMaster', text: 'Policy Master', icon: 'mdi-library-books' })
      arr.push({ name: 'claimRI', text: 'Reinsurance', icon: 'mdi-content-copy' })
      arr.push({ name: 'claimRemark', text: 'Remarks', icon: 'mdi-bookmark' })
      arr.push({ name: 'claimReservePaymentInfo', text: 'Reserve/Payment Summary', icon: 'mdi-calculator' })
      arr.push({ name: 'claimReserve', text: 'Reserves', icon: 'mdi-view-list' })
      arr.push({ name: 'claimRlRcvy', text: 'RI Recoveries', icon: 'mdi-redo-variant' })
      arr.push({ name: 'claimStats', text: 'Statistics', icon: 'mdi-chart-line' })
      arr.push({ name: 'claimStatus', text: 'Status', icon: 'mdi-history' })
      arr.push({ name: 'claimText', text: 'Text', icon: 'mdi-note-text' })
      arr.push({ name: 'xolRecovery', text: 'XOL Recoveries', icon: 'mdi-redo-variant' })
      arr.push({ name: 'xolWrksht', text: 'XOL Worksheets', icon: 'mdi-file-document-box' })
      return arr
    },
    initStatus() {
      return this.$store.state.claims.claimRegister.init
    },
    claimLifeCycle() {
      return this.$store.state.claims.claimDetail.claimLifeCycle - 1
    },
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    statisticses() {
      let result = clone(this.$store.state.claims.claimDetail.commonInfo.statisticses)
      if (result.length > 0) {
        return result
      }
      return []
    },
    loadBackListing() {
      return this.$store.state.claims.loadListing.action
    },
    objParam() {
      return this.$route.params.claimNo
    },
    currencyList() {
      return this.$store.state.claims.claimParams.currencyList
    },
    branchList() {
      return this.$store.state.claims.claimParams.branchList
    },
    payments() {
      return this.commonInfo.clmPayts
    },
    reserves() {
      return this.commonInfo.clmReses
    },
    riRecoveries() {
      return this.commonInfo.clmRiRcvys
    },
    claimParams() {
      return this.$store.state.claims.claimParams
    },
    paymentReserves() {
      return this.$store.state.claims.claimPayment.selectedReserves
    },
    claimStatusList() {
      return this.commonInfo.claimStatuses
    },
    handlerList() {
      return this.$store.state.claims.clmHdlr.handlerList
    },
    claimantNo() {
      for (let clmt of this.commonInfo.claimants) {
        if (clmt.clmNo === this.commonInfo.clmNo) {
          return clmt.clmtNo
        }
      }
      return {}
    },
    getClaimItemList() {
      for (let clamt of this.commonInfo.claimants) {
        if (clamt.clmNo === this.commonInfo.clmNo) {
          for (let clmIt of clamt.clmItems) {
            if (clmIt.clmNo === this.commonInfo.clmNo) {
              return clmIt.clmItem
            }
          }
        }
      }
      return {}
    },
    clmNo() {
      return (this.commonInfo || {}).clmNo
    }
  },
  methods: {
    async doInit() {
      // AR: Added to resolve invalid URL issues 7-Jun-2020
      this.loadingModal = true
      await Promise.all([this.$store.dispatch('claimEntryInit')])
      await Promise.all([this.$store.dispatch('underwritingInit')])
      this.getDistClsDesc()
      this.getFireConstrnClsDesc()
      this.getFireOccpnClsDesc()
      this.getFireOccpnClsLimDesc()
      this.fetchInterList()
      this.fetchClmDoc()
      if (this.claimDetail.init === 1) {
        this.loadInit()
      }
      this.loadingModal = false
    },
    async loadInit() {
      this.fetchClaimText()
      this.fetchClaimHandler()
      this.fetchAttachFile()
      this.fetchClaimRemark()
      this.fetchClaimRI()
      this.fetchClmHdrStats()
      this.fetchClmtStats()
      this.fetchClmItemStats()
      this.fetchClmByLossDate()
      this.fetchClmHistory()
      this.fetchClmAccts()
      this.fetchClmMtrDrvr()
    },
    getClaimant(key) {
      for (let param of this.commonInfo.claimants) {
        if (param.clmtNo === key) {
          return param
        }
      }
      return {}
    },
    getParamReserve(key) {
      for (let paramReserve of this.claimParams.reservesList) {
        if (paramReserve.value === key) {
          return paramReserve.label
        } else {
          return key
        }
      }
      return key
    },
    async fetchClmMtrDrvr() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.clmMtrDrvr
      if (apiUrl) {
        this.clmMtrDrvrLoading = true
        this.loading = true
        const result = await this.$http.get(expandURI(apiUrl, { clmNo: this.commonInfo.clmNo }))
        if (result && result.data) {
          const data = result.data
          if (data.data.clmMtrDrvr) {
            const clmMtrDrvr = data.data.clmMtrDrvr
            this.clmMtrDrvr = clmMtrDrvr
            this.clmMtrDrvr.drvDob = new Date(this.clmMtrDrvr.drvDob)
            this.clmMtrDrvr.drvLicExpDate = new Date(this.clmMtrDrvr.drvLicExpDate)
            this.calculateAge()
          }
          this.insured = data.data.insured
          this.mode = 'form'
        } else {
          this.$toast.error('Unexpected server response')
        }
        this.clmMtrDrvrLoading = false
      } else {
        this.$toast.error('Missing API URL (fetch Claim Motor Driver)')
      }
    },
    calculateAge() {
      this.clmMtrDrvr.drvAge = yearDiff(new Date(), this.clmMtrDrvr.drvDob)
    },
    yearDiff(date1, date2) {
      return yearDiff(date1, date2)
    },
    async fetchClaimText() {
      const apiUrl = this.claimDetail.menu.claimText
      if (apiUrl) {
        try {
          const expand = {
            clmNo: this.objParam ? this.objParam : this.commonInfo.clmNo
          }
          this.resetText()
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            this.claimText.clmNo = this.commonInfo.clmNo
            this.claimText.masterText = result.data.text
            this.claimText.claimantTexts = result.data.claimantTexts
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    resetText() {
      this.claimText.masterText = undefined
      this.claimText.claimantTexts = []
      this.claimText.itemTexts = []
    },
    async fetchClaimHandler() {
      this.$store.dispatch('fetchClmHdlrs')
    },
    populateHandlerNames(handlers, users) {
      let userMap = {}
      if (users && handlers) {
        users.forEach(function (user) {
          userMap[user.userId] = user
        })
        handlers.forEach(function (handler) {
          if (userMap[handler.userId]) {
            let user = userMap[handler.userId]
            handler.name = user.firstName + ' ' + user.lastName
          }
        })
      }
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    },
    formatDisplayDateTime4(dateTime) {
      if (dateTime) {
        return formatDisplayDateTime4(dateTime)
      } else {
        return ''
      }
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    },
    formatBooleanToNo(value) {
      if (value) {
        return '1'
      }
      return '0'
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    },
    async fetchAttachFile() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.clmAttachs
      if (apiUrl) {
        const expand = {
          clmNo: this.objParam ? this.objParam : this.commonInfo.clmNo
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result && result.data) {
          const data = result.data
          this.attachmentList = data.data.clmAttachs
        } else {
          this.$toast.error('Encountered an unexpected response from the server.')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim attachments)')
      }
      this.loading = false
    },
    async doDownload(job) {
      const apiURI = this.$store.state.claims.claimDetail.menu.downloadClaimAttachs
      if (apiURI) {
        try {
          const expand = {
            clmNo: this.commonInfo.clmNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand), {
            responseType: 'blob'
          })
          var headers = result.headers
          var blob = new Blob([result.data], { type: headers['content-type'] })
          var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
          downloadPrompt(blob, filename)
        } catch (err) {
          const { data } = err.response
          if (data) {
            // As the request is requesting blob, error has to be formatted back to json
            try {
              const errUrl = URL.createObjectURL(data)
              const errRes = await this.$http.get(errUrl)
              URL.revokeObjectURL(errUrl)
              if (errRes.data) {
                this.notify(errRes.data)
              }
            } catch (err2) {
              throw err2
            }
          }
        }
      } else {
        this.notify('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchClaimRemark() {
      const apiURI = this.$store.state.claims.claimListing.menu.getClaimRemarkList
      if (apiURI) {
        const expand = {
          clmNo: this.objParam ? this.objParam : this.commonInfo.clmNo
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result && result.data) {
          const data = result.data
          this.claimRemarkList = data.data
        } else {
          this.$toast.error('Encountered an unexpected response from the server.')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim attachments)')
      }
      this.loading = false
    },
    returnPage() {
      // if (this.objParam) {
      // this.$router.push({ name: 'mngClaim' })
      // } else {
      // SR5440
      // window.history.back()
      //   this.$router.go(-1)
      // }
      if (this.loadBackListing !== undefined) {
        this.returnToListing()
      } else {
        window.history.back()
      }
    },
    returnToListing() {
      if (this.loadBackListing === 'FromPolicy') {
        window.history.back()
      } else {
        this.$router.push({ name: 'mngClaim' })
      }
    },
    async fetchClaimRI() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.riHdrList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            clmNo: this.commonInfo.clmNo,
            includeAll: true
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          const { data } = result.data
          this.claimRITotalItems = result.totalItem
          if (data) {
            this.loading = false
            this.claimRIList = []
            data.map((riHdr) => {
              const convertRI = {
                clmNo: riHdr.clmNo,
                riType: riHdr.riType,
                riCo: riHdr.riCo,
                riCoDesc: riHdr.riCoDesc,
                acctNoSfx: riHdr.acctNoSfx,
                verCnt: riHdr.verCnt,
                proplXol: riHdr.proplXol,
                riTypeDesc:
                  this.getItemValue(riHdr.riType, this.riTypeList).label !== undefined
                    ? this.getItemValue(riHdr.riType, this.riTypeList).label
                    : riHdr.riType,
                proplXolDesc: this.getItemValue(riHdr.proplXol, this.proplXolList).label,
                riSipct: riHdr.riSipct,
                riLim: riHdr.riLim,
                priority: riHdr.priority,
                terminated: riHdr.terminated
              }
              this.claimRIList.push(convertRI)
            })
          } else {
            this.loading = false
            this.claimRIList = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.loading = false
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doQuery(row) {
      this.$router.push({
        name: 'queryClmPay',
        params: {
          clmNo: this.commonInfo.clmNo,
          clmtNo: row.item.clmtNo,
          clmItem: row.item.clmItem,
          docNo: row.item.docNo,
          tranType: row.item.tranType,
          clmResCat: row.item.clmResCat
        }
      })
    },
    doClmDocQuery(data) {
      this.queryDialog = true
      this.queryClmDocMode = true
      this.disabledSentDate = true
      this.disabledRecvDate = true
      this.clmDocForm.docHdg = data.item.docHdg
      this.clmDocForm.docHdgDesc = data.item.docHdgDesc
      this.clmDocForm.clmtNo = data.item.clmtNo
      this.clmDocForm.clmItem = data.item.clmItem
      this.clmDocForm.clmtNoClmItem = data.item.clmtNo + ' / ' + data.item.clmItem
      this.clmDocForm.inter = this.filterInterName1(data.item.inter)
      this.clmDocForm.tranType1 = data.item.tranType1
      this.clmDocForm.docNo = data.item.docNo
      this.clmDocForm.genDate = data.item.genDate
      this.clmDocForm.genBy = data.item.genBy
      this.clmDocForm.sentDate = data.item.sentDate
      this.clmDocForm.sentBy = data.item.sentBy
      this.clmDocForm.recvDate = data.item.recvDate
      this.clmDocForm.recvBy = data.item.recvBy
      this.clmDocForm.genDoc = data.item.genDoc
      this.clmDocForm.emailRecip = data.item.emailRecip
      this.clmDocForm.smsRecip = data.item.smsRecip
      this.clmDocForm.emailAgt = data.item.emailAgt
      this.clmDocForm.smsAgt = data.item.smsAgt
      this.clmDocForm.createdBy = data.item.createdBy
      this.clmDocForm.createdDate = data.item.createdDate
      this.clmDocForm.modifiedBy = data.item.modifiedBy
      this.clmDocForm.modifiedDate = data.item.modifiedDate
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      setTimeout(() => {
        this.queryMode = false
      }, 200)
      this.reviewDialog = false
    },
    doQueryClose() {
      this.resetValidator()
      this.resetMessages()
      this.queryDialog = false
      setTimeout(() => {
        this.queryClmDocMode = false
      }, 200)
    },
    async fetchClmHdrStats() {
      const apiURI = this.$store.state.claims.claimDetail.menu.getClmHdrStats
      if (apiURI) {
        const expand = {
          clmNo: this.objParam ? this.objParam : this.commonInfo.clmNo
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result && result.data) {
          const data = result.data
          this.clmHdrStatList = data.data.clmHdrStats
        } else {
          this.$toast.error('Encountered an unexpected response from the server.')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim header Statistics)')
      }
      this.loading = false
    },
    async fetchClmtStats() {
      const apiURI = this.$store.state.claims.claimDetail.menu.getClmtStats
      if (apiURI) {
        const expand = {
          clmNo: this.objParam ? this.objParam : this.commonInfo.clmNo,
          clmtNo: this.claimantNo
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result && result.data) {
          const data = result.data
          this.clmtStatList = data.data.clmtStats
        } else {
          this.$toast.error('Encountered an unexpected response from the server.')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim header Statistics)')
      }
      this.loading = false
    },
    async fetchClmItemStats() {
      const apiURI = this.$store.state.claims.claimDetail.menu.getClmItemStats
      if (apiURI) {
        const expand = {
          clmNo: this.objParam ? this.objParam : this.commonInfo.clmNo,
          clmtNo: this.claimantNo,
          clmItem: this.getClaimItemList
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result && result.data) {
          const data = result.data
          this.clmItemStatList = data.data.clmItemStats
        } else {
          this.$toast.error('Encountered an unexpected response from the server.')
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim header Statistics)')
      }
      this.loading = false
    },
    async fetchClmByLossDate() {
      this.clmByLossDateLoading = true
      const { page, itemsPerPage } = this.clmByLossDatePagination
      const expand = {
        page: page - 1,
        size: itemsPerPage
      }
      const apiUrl = this.$store.state.claims.claimDetail.menu.clmByLossDate
      if (apiUrl) {
        this.clmByLossDateLoading = true
        const result = await this.$http.get(
          filterQuery(
            expandURI(apiUrl, expand),
            { clmNo: this.commonInfo.clmNo },
            this.clmByLossDatePagination.sortBy,
            this.clmByLossDatePagination.sortDesc
          )
        )
        if (result && result.data) {
          const data = result.data
          this.clmByLossDateTotalItems = data.data.totalItems
          this.clmByLossDateList = data.data.clmMasterList
        } else {
          this.$toast.error('Unexpected server response')
        }
      } else {
        this.$toast.error('Missing API URL (fetch Claim by Similar Loss Date)')
      }
      this.clmByLossDateLoading = false
    },
    async fetchClmHistory() {
      this.clmHistoryLoading = true
      const apiUrl = this.$store.state.claims.claimDetail.menu.history
      if (apiUrl) {
        try {
          const { page, itemsPerPage } = this.clmHistoryPagination
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            clmNo: this.commonInfo.clmNo
          }
          let filters = {
            blank: ''
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), filters, this.clmHistoryPagination.sortBy, this.clmHistoryPagination.sortDesc))
          if (result && result.data) {
            const data = result.data.data.clmHistoryList
            this.clmHistoryTotalItems = result.data.data.totalItems
            if (data) {
              this.$set(this, 'historyItems', data)
            } else {
              this.$set(this, 'historyItems', [])
            }
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim release txn)')
      }
      this.clmHistoryLoading = false
    },
    async fetchClmDoc(options) {
      this.clmDocLoading = true
      const { page, itemsPerPage } = this.clmDocPagination
      let expand = {
        page: page - 1,
        size: itemsPerPage,
        clmNo: this.objParam ? this.objParam : this.commonInfo.clmNo,
        options: options
      }
      const apiUrl = this.$store.state.claims.claimDetail.menu.getClmDoctList
      if (apiUrl) {
        try {
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), this.filter, this.clmDocPagination.sortBy, this.clmDocPagination.sortDesc)
          )
          if (result) {
            this.clmDocTotalItems = result.data.totalElements
            const { data } = result.data
            this.clmDocs = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  tranId: datamap.tranId,
                  docHdg: datamap.docHdg,
                  docHdgDesc: this.filterDocHdgNo(datamap.docHdg),
                  clmNo: datamap.clmNo,
                  clmtNo: datamap.clmtNo,
                  clmItem: datamap.clmItem,
                  inter: datamap.inter === undefined ? '' : datamap.inter,
                  clmResCat: datamap.clmResCat === undefined ? '' : datamap.clmResCat,
                  branch: datamap.branch === undefined ? '' : datamap.branch,
                  tranType1: datamap.tranType1 === undefined ? '' : datamap.tranType1,
                  docNo: datamap.docNo === undefined ? '' : datamap.docNo,
                  genDoc: datamap.genDoc,
                  emailRecip: datamap.emailRecip,
                  smsRecip: datamap.smsRecip,
                  emailAgt: datamap.emailAgt,
                  smsAgt: datamap.smsAgt,
                  genDate: datamap.genDate,
                  genBy: datamap.genBy === '0' ? '' : datamap.genBy,
                  sentDate: datamap.sentDate,
                  sentBy: datamap.sentBy === '0' ? '' : datamap.sentBy,
                  recvDate: datamap.recvDate,
                  recvBy: datamap.recvBy === '0' ? '' : datamap.recvBy,
                  delDoc: datamap.delDoc,
                  createdBy: datamap.createdBy,
                  createdDate: datamap.createdDate,
                  modifiedBy: datamap.modifiedBy,
                  modifiedDate: datamap.modifiedDate
                }
                this.clmDocs.push(convertList)
              })
            }
          }
          this.clmDocLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.clmDocLoading = false
        }
      }
    },
    async fetchInterList() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.getInterName1List
      if (apiUrl) {
        try {
          this.interlist = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'interlist', result.data.dataList)
          }
        } catch (err) {
          this.interlist = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchClmAccts() {
      this.clmAcctLoading = true
      const { page, itemsPerPage } = this.clmAcctPagination
      const expand = {
        page: page - 1,
        size: itemsPerPage
      }
      const apiUrl = this.$store.state.claims.claimDetail.menu.clmAccts
      if (apiUrl) {
        this.clmAcctLoading = true
        const result = await this.$http.get(
          filterQuery(expandURI(apiUrl, expand), { clmNo: this.commonInfo.clmNo }, this.clmAcctPagination.sortBy, this.clmAcctPagination.sortDesc)
        )
        if (result && result.data) {
          const data = result.data
          this.clmAcctTotalItems = data.data.totalItems
          this.clmAcctList = data.data.clmAcctList
        } else {
          this.$toast.error('Unexpected server response')
        }
      } else {
        this.$toast.error('Missing API URL (fetch Claim Accounts)')
      }
      this.clmAcctLoading = false
    },
    async getDistClsDesc() {
      const apiURI = this.$store.state.claims.claimDetail.menu.getDistClsDesc
      if (apiURI) {
        const expand = {
          distCls: this.commonInfo.distCls
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.keyRiskForm.distClsDesc = data.distClsDesc
        }
      }
    },
    async getFireConstrnClsDesc() {
      const apiURI = this.$store.state.claims.claimDetail.menu.getFireConstrnClsDesc
      if (apiURI) {
        const expand = {
          constnCls: this.commonInfo.constnCls
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.keyRiskForm.constnClsDesc = data.constnClsDesc
        }
      }
    },
    async getFireOccpnClsDesc() {
      const apiURI = this.$store.state.claims.claimDetail.menu.getFireOccpnClsDesc
      if (apiURI) {
        const expand = {
          occpnCls: this.commonInfo.occpnCls
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.keyRiskForm.occpnClsDesc = data.occpnClsDesc
        }
      }
    },
    async getFireOccpnClsLimDesc() {
      const apiURI = this.$store.state.claims.claimDetail.menu.getFireOccpnClsLimDesc
      if (apiURI) {
        const expand = {
          occpClsLim: this.commonInfo.occpClsLim
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.keyRiskForm.occpClsLimDesc = data.occpClsLimDesc
        }
      }
    },
    doView(row) {
      this.$router.push({
        name: 'queryClmRIHdr',
        params: {
          clmNo: this.commonInfo.clmNo,
          riType: row.item.riType,
          riCo: row.item.riCo,
          acctNoSfx: row.item.acctNoSfx,
          verCnt: row.item.verCnt
        }
      })
    },
    async doPromptRemove() {
      this.showDeletePrompt = true
    },
    async doRemove() {
      this.resetMessages()
      try {
        const apiUrl = this.$store.state.claims.claimListing.menu.deleteClaim
        if (apiUrl) {
          this.loading = true
          const reqData = {
            clmNo: this.commonInfo.clmNo
          }
          await this.$http.post(apiUrl, reqData)
          this.showDeletePrompt = false
          this.showDeleteConfirm = true
        } else {
          this.showDeletePrompt = false
          this.$toast.error('API Url not found')
        }
        this.loading = false
      } catch (err) {
        this.showDeletePrompt = false
        this.loading = false
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    },
    doExit() {
      this.showDeleteConfirm = false
      this.$router.push({ name: 'mngClaim' })
    },
    filterDocHdgNo(dt) {
      for (var q = 0; q < this.clmDocNoList.length; q++) {
        if (this.clmDocNoList[q].code === dt) {
          return this.clmDocNoList[q].codeValue
        }
      }
    },
    filterInterName1(val) {
      for (let inter of this.interlist) {
        if (inter.value === val) {
          return inter.label
        }
      }
      return ''
    },
    async redirect() {
      this.loadingModal = true
      let data = {
        item: {
          polNo: this.commonInfo.polNo,
          renCnt: this.commonInfo.renCnt,
          endtCnt: this.commonInfo.endtCnt
        }
      }
      await this.$store.dispatch('dispatchSave', { key: 'QueryClaim', data: { clmNo: this.commonInfo.clmNo } })
      await this.$store.dispatch('reviewPolicy', data).then(() => {
        this.$router.push({ name: 'queryPolicy' })
        this.loadigModal = false
      })
    },
    onScroll(e) {
      // debounce if scrolling fast
      this.timeout && clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        const { scrollTop } = e.target
        const rows = Math.ceil(scrollTop / this.rowHeight)
        this.start = rows + this.perPage > this.riRecoveries.length ? this.riRecoveries.length - this.perPage : rows
        this.$nextTick(() => {
          e.target.scrollTop = scrollTop
        })
      }, 20)
    }
  },
  watch: {
    clmNo: function (value) {
      this.doInit()
    },
    pagination: function (value) {
      this.fetchClaimRI()
    },
    clmByLossDatePagination: function (value) {
      this.fetchClmByLossDate()
    },
    clmAcctPagination: function (value) {
      this.fetchClmAccts()
    },
    clmDocPagination: function (value) {
      this.fetchClmDoc(false)
    },
    clmHistoryPagination: function (value) {
      this.fetchClmHistory()
    }
  },
  mounted() {
    this.doInit()
  },
  created() {
    if (this.commonInfo.appID === 'MO') {
      this.displayMtrRisk = true
    } else if (this.commonInfo.appID === 'CA' && this.commonInfo.vesNo !== null) {
      this.displayCargoRisk = true
    } else if (this.commonInfo.appID === 'FI') {
      this.displayFireRisk = true
    } else if (this.commonInfo.appID === 'HU' && this.commonInfo.vesNo !== null) {
      this.displayHullRisk = true
    } else if (this.commonInfo.appID === 'MI') {
      this.displayMiscRisk = true
    } else {
      this.displayNoData = true
    }
  },
  components: {
    QueryClaimInfo,
    QueryClaimHeader,
    QueryClaimant,
    ClaimReserveInfo,
    CedantInfo,
    CustLog,
    ButtonPrintSchedule,
    XOLRecovery,
    XOLRecoveryListing
  },
  mixins: [ClaimCommonMixin, TableConst.default, listMixin]
}
</script>

<style lang="scss">
.sideMenuIcon {
  font-size: 2rem !important;
}
.sideMenuFont {
  font-size: 1rem !important;
}
#scroll-table {
  max-height: 294px;
  overflow: auto;
}
.queryClm .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.queryClm .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.queryClm .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.queryClm .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.queryClm .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.queryClm .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0 11px;
  font-size: 11px;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.queryClm .v-data-table > .v-data-table__wrapper > table {
  width: 100%;
  border-spacing: 0;
  font-size: 12px;
}
</style>
